import * as React from "react";
import { useState, useEffect } from "react";
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    EditButton,
    Edit,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    TextInput,
    Create,
    DateField,
    DateTimeInput,
    ReferenceManyField,
    useRecordContext,
    ReferenceManyToManyField,
    useDataProvider,
    AutocompleteInput,
    TabbedForm,
    FormTab,
    required,
    Pagination,
    Toolbar,
    SaveButton,
    DeleteButton,
} from 'react-admin';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import { OrderProductList } from "../components/orderProductList";
import { fetcherGetSync, fetcherSync } from "../utils/fetcher";
import config from "../config";
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "./../styles/common.js";
import Stack from '@mui/material/Stack';
import { OrderTransactionList, CreateTransactionForm } from "../components/orderTransactionList";
import {default as MUIButton} from '@mui/material/Button';
import RegulateOrderPriceModal from "../components/regulateOrderPriceModal";
import OrderStuartJobModal from "../components/orderStuartJobModal";

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { timestampToStrDate, dateToTimestamp, roundPrice, downloadFile } from "../utils/utils";

import MUITextField from '@mui/material/TextField';

const orderFilters = [
    <TextInput source="id" label="ID" alwaysOn />,
];


const exportOrders = () => {
    downloadFile(config.API_HOST+"/exports/orders", "orders.csv");
}
    

export const OrderList = props => (
    <List exporter={exportOrders} filters={orderFilters} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des commandes" />
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <OrderDateComponent label="Date" />
            <UserLinkComponent label="Client" />
            <ReferenceField link={false} source="statusId" reference="orderStatuses">
                <TextField source="title" label="Statut" />
            </ReferenceField>
            <PickupDateComponent label="Date d'enlèvement" />
            <DeliveredDateComponent label="Date de retour" />
                        {/*<FastDeliveryComponent label="Livraison rapide" />*/}
            <PriceComponent label="Prix (TTC)" />
        </Datagrid>
    </List>
);

/*export const FastDeliveryComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    if(record.fastDelivery > 0){
        return <span style={{...commonStyles.bold}}>Oui</span>
    }
    else {
        return <span>Non</span>
    }
}*/

export const PriceComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    let orderTotalPrice = roundPrice(getOrderTotalPrice(record.products, record.deliveryPrice));
    let totalPaidByClient = getTotalPaidByClient(record.transactions);

    let style= {...commonStyles.bold};
    if(orderTotalPrice != totalPaidByClient){
        style = {...style, ...commonStyles.red}
    }
    else {
        style = {...style, ...commonStyles.green}
    }
    return <>
        <span style={style}>{orderTotalPrice} €</span>
        <br />
        <span style={style}>{totalPaidByClient} €</span>
    </>
}

export const UserLinkComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    if(record.client){
        if(record.client.type){
            if(record.client.type.localeCompare("individual") === 0){
                return <a style={commonStyles.link} href={`#/users/individual/`+record.client.id}>{record.client.details.firstName + " " + record.client.details.lastName}</a>;
            }
            else {
                return <a style={commonStyles.link} href={`#/users/business/`+record.client.id}>{record.client.details.name}</a>;
            }
        }
        else {
            return <span>{record.client.email}</span>;
        }
    }
    else {
        return <span>Inconnu</span>;
    }
}

export const OrderDateComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    return <>
        <span>{timestampToStrDate(record.creationDate)}</span>
    </>
}

export const PickupDateComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    let statusStyle = {...commonStyles.bold};
    if(record.stuartPickupStatus.localeCompare("Livrée") == 0){
        statusStyle = {...statusStyle, ...commonStyles.green};
    }
    else if(["canceled", "expired", "voided"].includes(record.stuartPickupStatus)){
        statusStyle = {...statusStyle, ...commonStyles.red};
    }
    else {
        statusStyle = {...statusStyle, ...commonStyles.orange};
    }

    return <>
        <span>{timestampToStrDate(record.pickUpDate)}</span>
        <br />
        <span style={statusStyle}>{record.stuartPickupStatus}</span>
    </>
}

export const DeliveredDateComponent = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    let statusStyle = {...commonStyles.bold};
    if(record.stuartReturningStatus.localeCompare("Livrée") == 0){
        statusStyle = {...statusStyle, ...commonStyles.green};
    }
    else if(["canceled", "expired", "voided"].includes(record.stuartReturningStatus)){
        statusStyle = {...statusStyle, ...commonStyles.red};
    }
    else {
        statusStyle = {...statusStyle, ...commonStyles.orange};
    }

    return <>
        <span>{timestampToStrDate(record.deliveredDate)}</span>
        <br />
        <span style={statusStyle}>{record.stuartReturningStatus}</span>
    </>
}

/*<ReferenceField source="statusId" reference="orderStatuses" link={false}>
<TextField source="title" />
</ReferenceField>
<TextField source="creationDate" />
<TextField source="pickUpDate" />
<TextField source="deliveredDate" />*/

const AddressReferenceInput = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <ReferenceInput 
            label={props.source} 
            source={props.source}
            reference="address"
            filter={{ clientId: record.clientId }}>
                <SelectInput label={props.label} style={commonStyles.inputStyle} optionText="full" />
        </ReferenceInput>
    );
};

const UserReferenceInput = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <ReferenceInput 
            label="Client" 
            source="clientId" 
            reference="users">
                <AutocompleteInput disabled style={commonStyles.inputStyle} optionText="full" label="Client" />
        </ReferenceInput>
    );
};

const OrderDateInput = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <MUITextField style={props.style} margin="dense" value={timestampToStrDate(record[props.source])} disabled label={props.label} />
    );
};

const OrderStatusInput = () => {
    const record = useRecordContext(); // ???

    const dataProvider = useDataProvider();
    const [ref, setRef] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const [stuartJobPickupModalVisible, setStuartJobPickupModalVisible] = React.useState(false);
    const [stuartJobDeliveryModalVisible, setStuartJobDeliveryModalVisible] = React.useState(false);

    useEffect(() => {
        dataProvider.getOne('orderStatuses', { id: record.statusId })
            .then(({ data }) => {
                setRef(data.ref);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, [record]);

    if (loading) return <span style={{textAlign: "center"}}>CHARGEMENT</span>;
    if (error){
        return <span>ERREUR</span>;
    }
    if (!ref) return null;

    const styles = {
        innerSpan: {
            marginLeft: 20,
            display: "block",
            marginBottom: 10
        },
        innerSpanNoLeftMargin: {
            marginLeft: 0,
        },
        buttonGroup: {
            marginTop: 20
        }
    }

    function setOrderStatus(orderId, statusRef){
        if(window.confirm("Confirmez-vous le changement de statut de la commande ?")){
            var order = fetcherGetSync(config.API_HOST+"/orders/"+orderId);
            if(order){
                var statuses = fetcherGetSync(config.API_HOST+"/orderStatuses/");
                let chosenStatus = null;
                for(let status of statuses){
                    if(status.ref.localeCompare(statusRef) == 0){
                        chosenStatus = status;
                    }
                }
                if(chosenStatus){
                    var order = fetcherSync(config.API_HOST+"/orders/"+orderId, "PUT", {
                        ...order,
                        statusId: chosenStatus.id
                    });

                    setTimeout(() => window.location.reload(true), 1000);
                }
            }
        }
    }

    function getStuartDetails(jobId){
        /*let res = null;
        console.log("jobInfos");
        console.log(jobInfos);
        console.log(Object.keys(jobInfos).includes(jobId));
        if(Object.keys(jobInfos).includes(jobId)){
            res = jobInfos[jobId];
            console.log("get from dict")
        }
        else {
            res = fetcherGetSync(config.API_HOST+"/orders/stuart/jobinfos/"+jobId);
            jobInfos[jobId] = res;
            console.log("get from req")
        }*/
        let res = fetcherGetSync(config.API_HOST+"/orders/stuart/jobinfos/"+jobId);

        console.log("res.body")
        console.log(res.body)

        if(res.statusCode == 200 && res.body.status){
            if(res.body.status.localeCompare("scheduled") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Prévu</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                    </>
                )
            }
            else if(res.body.status.localeCompare("searching") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Recherche d'un livreur en cours</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                    </>
                )
            }
            else if(res.body.status.localeCompare("in_progress") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Livraison en cours</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                        {res.body.driver && res.body.driver.display_name && res.body.driver.phone ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Livreur : </strong>{res.body.driver.display_name} ({res.body.driver.phone})</span> : <></>}
                    </>
                )
            }
            else if(res.body.status.localeCompare("finished") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Livré</span><br />
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                        {res.body.driver && res.body.driver.display_name && res.body.driver.phone ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Livreur : </strong>{res.body.driver.display_name} ({res.body.driver.phone})</span> : <></>}
                    </>
                )
            }
            else if(res.body.status.localeCompare("canceled") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Annulé</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                        
                    </>
                )
            }
            else if(res.body.status.localeCompare("expired") == 0 || res.body.status.localeCompare("voided") == 0){
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>Expiré (aucun livreur trouvé)</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                    </>
                )
            }
            else {
                return (
                    <>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Informations stuart</strong></span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Statut : </strong>{res.body.status}</span>
                        <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Horaire : </strong>{timestampToStrDate(dateToTimestamp(new Date(res.body.pickup_at)))}</span>
                        {res.body.driver && res.body.driver.transport_type ? <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}><strong>Mode de transport : </strong>{res.body.driver.transport_type}</span> : <></>}
                    </>
                )
            }
        }
        else {
            return (
                <>
                    <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Aucun retrait stuart n'est prévu.</span>
                </>
            )
        }
    }


    var content = <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Une erreur s'est produite</span>;

    if(ref.localeCompare("STARTED") == 0){
        
        content = (
            <>
                <span>La commande a été passée par le client, elle sera retirée le {timestampToStrDate(record.pickUpDate)}</span>
                <br/>
                {getStuartDetails(record.stuartPickUpId)}

                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button onClick={() => setOrderStatus(record.id, "RECEIVED")}>Marquer comme reçue</Button>
                    <Button onClick={() => setStuartJobPickupModalVisible(true)}>Commander un nouveau retrait</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else if(ref.localeCompare("RECEIVING") == 0){
        content = (
            <div>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>La commande est en cours de livraison ou doit être bientôt livrée au pressing.</span>
                <br/>
                {getStuartDetails(record.stuartPickUpId)}

                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button onClick={() => setOrderStatus(record.id, "RECEIVED")}>Marquer comme reçue</Button>
                    <Button onClick={() => setStuartJobPickupModalVisible(true)}>Commander un nouveau retrait</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </div>
        )
    }
    else if(ref.localeCompare("RECEIVED") == 0){
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Stuart a déclaré que la commande a bien été livrée au pressing.</span>
                <br/>
                {getStuartDetails(record.stuartPickUpId)}

                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button color="secondary" onClick={() => setOrderStatus(record.id, "PAID")}>Marquer comme payée</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else if(ref.localeCompare("PAID") == 0){
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>La commande a bien été encaissée.</span>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Commande à livrer pour le : {timestampToStrDate(record.deliveredDate)}</span>
                
                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button color="secondary" onClick={() => setOrderStatus(record.id, "TREATED")}>Marquer comme prête</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else if(ref.localeCompare("TREATED") == 0){
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>La commande a bien été traitée, elle est prête pour un retour client.</span>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Commande à livrer pour le : {timestampToStrDate(record.deliveredDate)}</span>
                
                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button color="secondary" onClick={() => setOrderStatus(record.id, "RETURNING")}>Préparer une livraison Stuart</Button>
                    <Button color="secondary" onClick={() => setOrderStatus(record.id, "RETURNED")}>Marquer comme livrée</Button>
                    <Button onClick={() => setOrderStatus(record.id, "PAID")}>Retour au statut précédent</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else if(ref.localeCompare("RETURNING") == 0){
        // Gérer si livraison annulée
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>La commande est en cours de livraison ou doit être bientôt livrée au client.</span>
                <br/>
                {getStuartDetails(record.stuartDeliveredId)}

                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button color="secondary" onClick={() => setStuartJobDeliveryModalVisible(true)}>Commander une livraison stuart</Button>
                    <Button onClick={() => setOrderStatus(record.id, "TREATED")}>Retour au statut précédent</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else if(ref.localeCompare("RETURNED") == 0){
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>Stuart a déclaré que la commande a bien été livrée au client.</span>
                <br/>
                {getStuartDetails(record.stuartDeliveredId)}
                
                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button onClick={() => setOrderStatus(record.id, "TREATED")}>Retour au statut précédent</Button>
                    <Button color="error" onClick={() => setOrderStatus(record.id, "CANCELLED")}>Annuler la commande</Button>
                </ButtonGroup>
            </>
        )
    }
    else {
        content = (
            <>
                <span style={{...styles.innerSpan, ...styles.innerSpanNoLeftMargin}}>La commande a été annulée.</span>
                    
                <ButtonGroup style={styles.buttonGroup} variant="contained" aria-label="outlined primary button group">
                    <Button onClick={() => setOrderStatus(record.id, "TREATED")}>Retour au statut précédent</Button>
                </ButtonGroup>
             </>
        )
    }
    return (
        <Card style={{width: "100%", textAlign: "center"}}>
            <CardContent>
                <Typography variant="h5" component="p" style={{marginBottom: 20}}>
                    Statut de la commande
                </Typography>
                {content}
                <OrderStuartJobModal opened={stuartJobPickupModalVisible} setOpened={setStuartJobPickupModalVisible} date={record.pickUpDate} type="pickup" />
                <OrderStuartJobModal opened={stuartJobDeliveryModalVisible} setOpened={setStuartJobDeliveryModalVisible} date={record.deliveredDate} type="delivery" />
            </CardContent>
        </Card>
    )
};

/*const OrderFastDeliveryComponent = (props) => {
    const record = useRecordContext();

    const style = {
        color: "#c0392b",
        fontSize: 20,
        textAlign: "center",
        width: "100%",
        marginTop: 10,
        marginBottom: 10,
    }

    if(record.fastDelivery > 0){
        return <p style={style}>Commande avec option livraison express !</p>
    }
    else {
        return null;
    }
};*/

const OrderInvoiceComponent = (props) => {
    const record = useRecordContext();

    return <ButtonGroup variant="contained" aria-label="outlined primary button group">
        <Button onClick={() => window.location.href=config.API_HOST+"/orders/"+record.invoiceToken+"/invoice"}>Voir la facture</Button>
        <Button onClick={() => window.location.href=config.API_HOST+"/orders/"+record.invoiceToken+"/invoice/download"}>Télécharger la facture</Button>
    </ButtonGroup>
    
};

const OrderNotFullyPaidComponent = (props) => {
    const record = useRecordContext();
    const [modalOpened, setModalOpened] = React.useState(false);
    const [amountToRegulate, setAmountToRegulate] = React.useState(0);

    const refreshTotalPrice = () => {
        if(record != undefined){
            //let result = fetcherGetSync(config.API_HOST+"/orderTransactions?filter={\"orderId\":"+record.id+"}", "GET");

            let orderTotalPrice = getOrderTotalPrice(record.products, record.deliveryPrice);
            let totalPaidByClient = getTotalPaidByClient(record.transactions);
        
            setAmountToRegulate(roundPrice(orderTotalPrice-totalPaidByClient));
        }
    }

    const refreshOrderTransactions = () => {
        if(record != undefined){
            let result = fetcherSync(config.API_HOST+"/orders/"+record.id+"/refreshOrderTransactions", "POST");

            window.location.reload(true);
            
        }
    }

    useEffect(() => {
        if(record != undefined){
            let orderTotalPrice = getOrderTotalPrice(record.products, record.deliveryPrice);
            let totalPaidByClient = getTotalPaidByClient(record.transactions);
            setAmountToRegulate(roundPrice(orderTotalPrice-totalPaidByClient));
        }
    }, [record]);

    if (!record) return null;

    
    const titleStyle = {
        textAlign: "center",
        width: "100%",
        color: "rgb(80, 80, 80)"
    };

    if(amountToRegulate > 0){
        return (
            <>
                <Card style={{margin: "auto", marginBottom: "30px", marginTop: "30px", textAlign: "center", border: "2px solid #e74c3c"}}>
                    <CardContent>
                        <Typography variant="h5" component="h6" style={{...titleStyle, borderBottom: "1px solid black", paddingBottom: "5px"}}>
                            Montant de la commande à vérifier
                        </Typography>

                        <Typography id="modal-modal-description" sx={{ mt: 2, color: "red" }}>
                            Pensez à rafraîchir les transactions avant d'effectuer une quelconque action.
                        </Typography>


                        <p>Le client n'a pas payé la totalité de la commande.</p>

                        <Stack spacing={2}>
                            <MUIButton variant="contained" color="success" onClick={() => {refreshOrderTransactions()}}>Rafraîchir les transactions</MUIButton>
                            <MUIButton variant="contained" onClick={() => {refreshTotalPrice(); setModalOpened(true)}}>Régler la différence</MUIButton>
                    </Stack>
                    </CardContent>
                </Card>

                <RegulateOrderPriceModal amount={amountToRegulate} opened={modalOpened} setOpened={setModalOpened} clientId={record.clientId} />
            </>
        );
    }
    else if(amountToRegulate < 0) {
        return (
            <>
                <Card style={{margin: "auto", marginBottom: "30px", marginTop: "30px", textAlign: "center", border: "2px solid #e74c3c"}}>
                    <CardContent>
                        <Typography variant="h5" component="h6" style={{...titleStyle, borderBottom: "1px solid black", paddingBottom: "5px"}}>
                        Montant de la commande à vérifier
                        </Typography>

                        <Typography id="modal-modal-description" sx={{ mt: 2, color: "red" }}>
                            Pensez à rafraîchir les transactions avant d'effectuer une quelconque action.
                        </Typography>

                        <p>Vous devez rembourser {-amountToRegulate}€ au client. Effectuez cela dans l'onglet transaction.</p>

                        <Stack spacing={2}>
                            <MUIButton variant="contained" color="success" onClick={() => {refreshOrderTransactions()}}>Rafraîchir les transactions</MUIButton>
                        </Stack>
                    </CardContent>
                </Card>

                <RegulateOrderPriceModal amount={amountToRegulate} opened={modalOpened} setOpened={setModalOpened} clientId={record.clientId} />
            </>
        );
    }
    
};

const getTotalPaidByClient = (transactions) => {
    let totalPaid = 0;
    for(let transaction of transactions){
        if(transaction.type.localeCompare("payment") == 0){
            if(transaction.status.localeCompare("succeeded") == 0){
                totalPaid = totalPaid + transaction.amount;
            }
        }
        else if(transaction.type.localeCompare("addition") == 0){
            if(transaction.status.localeCompare("succeeded") == 0){
                totalPaid = totalPaid + transaction.amount;
            }
        }
        else if(transaction.type.localeCompare("refund") == 0){
            if(transaction.status.localeCompare("succeeded") == 0){
                totalPaid = totalPaid - transaction.amount;
            }
        }
    }

    //return Math.round(totalPaid)/100;
    return roundPrice(totalPaid/100);
}

const getOrderTotalPrice = (products, deliveryPrice) => {
    var priceTTC = 0;
    for (const element of products) {
        priceTTC = priceTTC + element.price * element.count;
    }
    priceTTC = priceTTC + parseFloat(deliveryPrice);
 
    return roundPrice(priceTTC);
}

const PricesCards = (props) => {
    const record = useRecordContext();
    //const [totalPaidByClient, setTotalPaidByClient] = React.useState(0);

    /*useEffect(() => {

        if(record != undefined){
            let result = fetcherGetSync(config.API_HOST+"/orderTransactions?filter={\"orderId\":"+record.id+"}", "GET");

            setTotalPaidByClient(getTotalPaidByClient(result));
        }
            
    }, [record]);*/

    if (!record) return null;

    console.log("record.transactions")
    console.log(record.transactions)
   // setTotalPaidByClient(getTotalPaidByClient(record.transactions));
   
    let totalPaidByClient = getTotalPaidByClient(record.transactions)
    let priceTTC = getOrderTotalPrice(record.products, record.deliveryPrice);
    return (
        <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                <Card>
                    <CardContent>
                        <Typography variant="h5" component="div" style={{textAlign: "center"}}>
                            Prix total HT
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} style={{textAlign: "center", marginTop: "15px", marginBottom: "0"}} color="text.secondary" variant="h4" component="p">
                            {roundPrice(priceTTC/1.2)}€
                        </Typography>
                    </CardContent>
                </Card>
                <Card>
                    <CardContent>
                        <Typography variant="h5" component="div" style={{textAlign: "center"}}>
                            Prix total TTC
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} style={{textAlign: "center", marginTop: "15px", marginBottom: "0"}} color="text.secondary" variant="h4" component="p">
                            {roundPrice(priceTTC)}€
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} style={{textAlign: "center", marginTop: "10px", marginBottom: "0"}} color="text.secondary" variant="p" component="p">
                            Dont livraison : {roundPrice(record.deliveryPrice)}€ TTC
                        </Typography>
                    </CardContent>
                </Card>
                <Card>
                    <CardContent>
                        <Typography variant="h5" component="div" style={{textAlign: "center"}}>
                            Total payé par le client
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} style={{textAlign: "center", marginTop: "15px", marginBottom: "0"}} color="text.secondary" variant="h4" component="p">
                            {Math.round(totalPaidByClient*100)/100}€
                        </Typography>
                    </CardContent>
                </Card>
        </Stack>
    );
};

const CustomToolbar = props => (
    <Toolbar
        {...props}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
    >
        <SaveButton />
    </Toolbar>
);

export const OrderEdit = props => { 
    return(
    <Edit {...props} toolbar={<CustomToolbar />}>
        <PageListTitle text="Edition de la commande" />
        <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="general">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />

                <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                    <Stack>
                        <TextInput style={commonStyles.inputStyle} disabled source="id" label="ID" />
                        <UserReferenceInput />
                    </Stack>
                    <Stack>
                        <OrderDateInput disabled style={{...commonStyles.inputStyle, marginBottom: 28}} source="creationDate" label="Date de commande" />
                        <ReferenceInput disabled source="statusId" reference="orderStatuses">
                            <SelectInput disabled style={commonStyles.inputStyle} optionText="title" label="Statut de la commande" />
                        </ReferenceInput>
                    </Stack>
                </Stack>

                <Stack direction="row"  style={commonStyles.stackRow}>
                    <TextInput style={commonStyles.inputStyle} source="comments" multiline label="Commentaires" />
                </Stack>
            </FormTab>
            <FormTab label="paiement">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />

                <Stack spacing={5} style={commonStyles.stackColumn}>
                    <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                        <Stack>
                           {/* <TextInput style={commonStyles.inputStyle} disabled source="promotionId" label="Promotion utilisée" />*/}
                            <OrderInvoiceComponent />
                        </Stack>
                    </Stack>
                    <Stack>
                        <PricesCards />
                    </Stack>
                </Stack>

            </FormTab>
            <FormTab label="statut">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />
                
                <OrderStatusInput />

            </FormTab>
            <FormTab label="livraison">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />

                <Stack direction="row" spacing={10} style={commonStyles.stackRow}>
                    <Stack>
                        <OrderDateInput style={commonStyles.inputStyle} source="pickUpDate" label="Date de prise en charge demandée" />
                        <AddressReferenceInput source="pickUpAddressId" label="Adresse de prise en charge" />

                        <TextInput style={commonStyles.inputStyle} source="stuartPickUpId" label="ID Stuart de prise en charge" />

                    </Stack>
                    <Stack>
                        <OrderDateInput style={commonStyles.inputStyle} source="deliveredDate" label="Date de retour demandée" />
                        <AddressReferenceInput source="billingAddressId" label="Adresse de retour demandée" />

                        <TextInput style={commonStyles.inputStyle} source="stuartDeliveredId" label="ID Stuart de retour" />

                    </Stack>
                </Stack>

                <Stack direction="row"  style={commonStyles.stackRow}>
                    <SelectInput source="transport" label="Mode de livraison" validate={required()} choices={[
                        { id: 'bike', name: 'Vélo' },
                        { id: 'car', name: 'Voiture' },
                    ]} />
                </Stack>

            </FormTab>
            <FormTab label="produits">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />

                <OrderProductList />
                
            </FormTab>
            <FormTab label="transactions">

                {/*<OrderFastDeliveryComponent />*/}

                <OrderNotFullyPaidComponent />

                <OrderTransactionList />

                {/*<CreateTransactionForm />*/}
                
            </FormTab>
        </TabbedForm>
    </Edit>
);}

/*export const PostCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput source="userId" reference="users">
               <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="title" />
            <TextInput multiline source="body" />
       </SimpleForm>
    </Create>
);*/

/*
 <ReferenceManyField perPage={10} reference="address" target="clientId">
                <Datagrid>
                    <DateField source="id" />
                    <EditButton />
                </Datagrid>
            </ReferenceManyField>
*/